import type { DropshippingDto } from "../../../../api";
import { OrderShipmentsCard } from "../../../../components/common/order-shipments-card";

interface SaleDeliveryInformationProps {
  dropshipping?: DropshippingDto[] | null;
  showInternalCosts?: boolean;
}

export function SaleDeliveryInformation({
  dropshipping,
  showInternalCosts = false,
}: SaleDeliveryInformationProps) {
  return (
    <OrderShipmentsCard
      shipments={dropshipping}
      title="Delivery Information"
      showInternalCosts={showInternalCosts}
    />
  );
}
